// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesList_wrapper__QdHfx","messagesWrapper":"MessagesList_messagesWrapper__4N+yM","messages":"MessagesList_messages__7-irO"};